module.exports = __webpack_public_path__ + "img/cooperativismo.dfcfdab5.png";